export default ".box {\n  background: #f2f2f2;\n}\n.box .cta {\n  color: #1c69d3;\n  font-weight: bold;\n}"